import { UserFacingError } from './errors'

export class EquipmentNotFoundError extends UserFacingError {
  constructor() {
    super('Equipment not found')
    this.name = 'EquipmentNotFoundError'
  }
}

export class UnauthorizedEquipmentActionError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Only club managers and outfitter owners can manage equipment')
    this.name = 'UnauthorizedEquipmentActionError'
  }
}

export class NotOrgMemberEquipmentError extends UserFacingError {
  constructor() {
    super('Not an active org member')
    this.name = 'NotOrgMemberEquipmentError'
  }
}

export class EquipmentCategoryNotFoundError extends UserFacingError {
  constructor() {
    super('Equipment category not found')
    this.name = 'EquipmentCategoryNotFoundError'
  }
}

export class EquipmentCategoryInUseError extends UserFacingError {
  constructor() {
    super('Move items off this category first')
    this.name = 'EquipmentCategoryInUseError'
  }
}

export class DefaultEquipmentCategoryImmutableError extends UserFacingError {
  constructor() {
    super('Default categories cannot be renamed or deleted')
    this.name = 'DefaultEquipmentCategoryImmutableError'
  }
}

export class EquipmentCategoryNameConflictError extends UserFacingError {
  constructor() {
    super('An equipment category with this name already exists')
    this.name = 'EquipmentCategoryNameConflictError'
  }
}
